import { mdiClose, mdiCloseCircle } from '@mdi/js'
import Icon from '@mdi/react'
import IconButton from './IconButton'

interface IButtonX {
    onClick(event?: any): void
    overrides?: string
    clearInputIcon?: string
    clearInputIconColor?: string
    title?: string
    size?: number
}

const ButtonX = ({
    onClick,
    overrides,
    clearInputIcon,
    clearInputIconColor,
    title,
    size = 0.75,
}: IButtonX) => {
    return (
        <IconButton
            data-testid="IconButton_X"
            onClick={onClick}
            title={title}
            className={overrides}
        >
            <Icon
                path={
                    clearInputIcon === 'closeCircle' ? mdiCloseCircle : mdiClose
                }
                color={clearInputIconColor}
                size={size}
            />
        </IconButton>
    )
}

export default ButtonX
